<template>
	<div class="card">
		<div class="card-body">
			<h5><i class="fas fa-users"></i> Acceso Campus</h5>
			<b-form-group id="input-group-1" label="Selecciona Campus">
				<b-form-select
					v-model="selectedCampus"
					:options="optionsCampus"
					:class="{ 'is-invalid': camposVacio.idCampus }"
					@change="camposValidacion('seleccionCampus')"
					><b-form-select-option :value="null" disabled
						>-- Seleccion auna opción --</b-form-select-option
					>
				</b-form-select>
				<span v-if="error.idCampus" style="color:red">{{
					error.idCampus[0]
				}}</span>
			</b-form-group>
			<b-form-group id="input-group-1" label="Selecciona el rol alumno">
				<b-form-select
					v-model="selectedPerfil"
					:options="optionsPerfil"
					:class="{ 'is-invalid': camposVacio.rol }"
					@change="camposValidacion('seleccionRol')"
					><b-form-select-option :value="null" disabled
						>-- Seleccion auna opción --</b-form-select-option
					>
				</b-form-select>
				<span v-if="error.rol" style="color:red">{{ error.rol[0] }}</span>
			</b-form-group>
			<b-button block variant="primary" @click="updateAcceso()"
				><b-spinner v-if="arrayButton[0].btnCampus" small> </b-spinner>
				{{ arrayButton[0].msgButtonAcceso }}
			</b-button>
			<br />
			<hr />
			<div>
				<h5><i class="fas fa-bars"></i> Listado Campus Inscritos</h5>
				<b-alert v-if="jsonCampusAlumno.length == 0" show variant="warning"
					>No existen campus asociado al alumno.</b-alert
				>
				<ul id="example-1">
					<li v-for="(campus, index) in jsonCampusAlumno" v-bind:key="index">
						#{{ campus.idCampus }} {{ campus.titulo }}
					</li>
				</ul>
			</div>
		</div>
		<toastComponent ref="toastComponent"></toastComponent>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import toastComponent from "@/components/toastComponent";
export default {
	components: {
		toastComponent
	},
	data() {
		return {
			camposVacio: {},
			optionsCampus: [],
			selectedCampus: null,
			error: {},
			optionsPerfil: [
				{ value: 1, text: "Alumno" },
				{ value: 2, text: "Profesor" },
				{ value: 3, text: "Admin" }
			],
			selectedPerfil: null,
			arrayButton: [{ msgButtonAcceso: "Agregar Campus", btnCampus: false }],
			campusAlumno: []
		};
	},
	computed: {
		...mapState("alumno", ["jsonAlumno"]),
		...mapState("alumno", ["jsonCampusAlumno"]),
		listadoCampus() {
			if (this.jsonAlumno.idAlumno) {
				this.getCampusAlumno(this.jsonAlumno.idAlumno);
			}
		}
	},
	methods: {
		camposValidacion(param) {
			if (param == "seleccionCampus") {
				this.camposVacio.idCampus = false;
			}
			if (param == "seleccionRol") {
				this.camposVacio.rol = false;
			}
		},
		updateAcceso() {
			let form = {
				idCampus: this.selectedCampus,
				idAlumno: this.jsonAlumno.idAlumno,
				rol: this.selectedPerfil
			};

			this.axios
				.post("api/addCampus", form)
				.then(res => {
					let estado = res.data.estado;
					let arrayToast = {
						msg: "",
						title: "",
						variant: ""
					};

					switch (estado) {
						case "camposVacios":
							this.error = res.data.errores;
							this.camposVacio = this.error;
							break;
						case "nuevoCampus":
							arrayToast.msg = res.data.msg;
							arrayToast.title = "Exito";
							arrayToast.variant = "success";

							this.$refs.toastComponent.makeToast(arrayToast);
							this.jsonCampusAlumno.push({
								idCampus: res.data.infoCampus.idCampus,
								titulo: res.data.infoCampus.titulo
							});
							break;
						case "cambioPerfilCampus":
							arrayToast.msg = res.data.msg;
							arrayToast.title = "Atencion";
							arrayToast.variant = "warning";

							this.$refs.toastComponent.makeToast(arrayToast);
							break;
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCampus() {
			this.axios
				.get("api/getCampus")
				.then(res => {
					let campus = res.data.getCampus;
					for (let campu of campus) {
						this.optionsCampus.push({
							value: campu.idCampus,
							text: campu.titulo
						});
					}
				})
				.catch(err => {
					console.log(err);
				});
		}
	},
	mounted() {
		this.getCampus();
	}
};
</script>
